import PageContainer from '@/components/ui/containers/PageContainer'
import { SubscribePlaceholder } from '@/shared/ui/placeholder/SubscribePlaceholder'

export function SubscribePage() {
  return (
    <PageContainer>
      <SubscribePlaceholder />
    </PageContainer>
  )
}
